import { ExpressPaymentsBaseService } from '../../../../js/Common/Payments/ExpressPaymentsBaseService';
import { useVehicleDetails } from '@vue3/src/Composables/VehicleDetails/useVehicleDetails';
import { useExpressCheckoutStore } from '../../store/ExpressCheckout/ExpressCheckoutStore/ExpressCheckoutStore';
import {
  fetchRegionsFromApi,
  getEnabledStepsInTransact,
} from '../../../../js/Common/Payments/TransactCommonUtility';
import { Payments } from './Payments';
import { sentTradeDetailsProgramme } from './TransactSummaryService';

export class ExpressPayments extends ExpressPaymentsBaseService {
  static async getVehicleDetails(vin = '') {
    let vehicleDetails = await useVehicleDetails(vin);
    return vehicleDetails;
  }

  static async getVehicleDetailsByVin(vin = '') {
    let response = await this.getVehicleDetails(vin);
    return response;
  }

  static vehicleDetails(vin = '') {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise((resolve) => {
      (async () => {
        let response = await this.getVehicleDetails(vin);
        return resolve({ data: response });
      })();
    });
  }

  static getEnabledTransactSteps(selectedPaymentSettings, incentivesData) {
    console.log('get Enabled Transact steps');
    return getEnabledStepsInTransact(selectedPaymentSettings, incentivesData);
  }

  formatPaymentSettings(paymentSettings) {
    this.dividePaymentSettings(paymentSettings.digitalRetailingSettings);
    const expressCheckoutStore = useExpressCheckoutStore();
    expressCheckoutStore.serviceAndProtectionPlans = paymentSettings.serviceAndProtectionPlans;

    expressCheckoutStore.creditScores[constants.LEASE.toLowerCase()] =
      paymentSettings.leaseCreditScores;

    expressCheckoutStore.creditScores[constants.FINANCE.toLowerCase()] =
      paymentSettings.financeCreditScores;
  }

  dividePaymentSettings(digitalRetailingSettings) {
    const expressCheckoutStore = useExpressCheckoutStore();
    digitalRetailingSettings.forEach((setting, index) => {
      if (setting.paymentType.toLowerCase() === constants.LEASE.toLowerCase()) {
        expressCheckoutStore.paymentSettings.lease = setting;
      }

      if (setting.paymentType.toLowerCase() === constants.FINANCE.toLowerCase()) {
        expressCheckoutStore.paymentSettings.finance = setting;
        expressCheckoutStore.paymentSettings.cash = setting;
      }
    });
  }

  getLeaseSpecialIncentives(zipCode) {
    return this.getSpecialIncentives(constants.LEASE.toLowerCase(), zipCode);
  }
  getFinanceSpecialIncentives(zipCode) {
    return this.getSpecialIncentives(constants.FINANCE.toLowerCase(), zipCode);
  }

  static resetSummaryData() {
    const expressCheckoutStore = useExpressCheckoutStore();
    for (let property in SUMMARY_DATA_DETAILS) {
      expressCheckoutStore[EXPRESS_SET_SUMMARY_DATA]({
        type: property,
        value: '',
      });
    }
  }

  static ConvertPaymentToNumber(value) {
    if (!value) return '';
    value = value.toString();
    value = value.replace('$', '').replace(',', '');
    return +value;
  }

  static async getRegions(zipCode) {
    let response = await fetchRegionsFromApi(zipCode);
    return response.data;
  }

  static getDealerZipCode() {
    if (!window?.zip) return '';
    let dealerZipCode = window.zip;
    return dealerZipCode.split('-')[0];
  }

  static async getAtcPayments(postData) {
    postData.IsOffersites = true;
    let Url = `${atob(window.portalUrl)}OfferManager/Service/PaymentAPI/GetATCPayments`;
    let response = await axios.post(Url, postData);
    return response.data;
  }

  static getSelectedCity(cities, userDetails) {
    for (let i = 0; i < cities?.length; i++) {
      if (cities[i].City.toLowerCase() === userDetails.city.toLowerCase()) {
        return i;
      }
    }
    return '';
  }

  static async getPayments(postData) {
    if (typeof window.vin !== 'undefined') {
      postData.VIN = window.vin;
    }

    if (typeof window.styleId !== 'undefined') {
      postData.StyleId = +window.styleId;
    }

    postData.AccountID = window.vdpAccountId ? +window.vdpAccountId : +window.accountId;
    postData.IsOffersites = true;

    let response = await axios.post(atob(window.paymentapi), postData);
    return response.data;
  }

  static getTotalIncentivesAmount(paymentsData) {
    let amount = 0;

    amount = paymentsData.IncentiveCash + paymentsData.DealerCash;

    return amount;
  }

  static async getCurrentVehicle(consumerId) {
    return await axios.get(`${window.ApiBaseUrl}/Consumer/Details/${consumerId}`);
  }

  static sendNegativeWrappedValue(number) {
    number = Payments.conventStringToNumber(number);
    if (number < 0) {
      return `($${(number * -1).toLocaleString()})`;
    } else {
      return `$${number.toLocaleString()}`;
    }
  }

  static getTotalServiceProtectionPlans(summaryData) {
    let amount = 0;
    for (let item of summaryData.serviceProtectionPlan) {
      if (Number(item.cashPrice)) {
        amount += Payments.conventStringToNumber(item.cashPrice);
      }
    }

    return amount;
  }

  static getTradePaymentValues(details) {
    if (!details) {
      return '';
    }

    if (details.paymentType) {
      if (window.isauthenticated === 'True' && details.paymentType.toLowerCase() === 'lease') {
        if (details.paymentsRemaining && details.monthlyPayment) {
          let val = +details.paymentsRemaining * +details.monthlyPayment;
          if ('residual' in details) {
            val = val + +details.residual;
          }
          return val;
        }
      }

      if (
        details.paymentType.toLowerCase() === 'finance' ||
        details.paymentType.toLowerCase() === 'cash' ||
        details.paymentType.toLowerCase() === 'lease'
      ) {
        if (details.paymentsRemaining && details.monthlyPayment) {
          return +details.paymentsRemaining * +details.monthlyPayment;
        }
      }
    }

    return 0;
  }

  static firePaymentsEvent(eventModel, paymentsData) {
    let paymentsEvent = {
      tradeIn: paymentsData.TradeEquity,
      MSRP: parseFloat(paymentsData.MSRP.replace(/[$,]/g, '')),
      payment: paymentsData.Payment.replace(/[$,]/g, ''),
      incentives: paymentsData.IncentiveCash,
      sellingPrice: parseFloat(paymentsData.PurchasePrice.replace(/[$,]/g, '')),
      paymentDueAtSigning: paymentsData.DueAtSigning.replace(/[$,]/g, ''),
      discount: paymentsData.Discount,
    };
    let eventData = { ...eventModel, ...paymentsEvent };
    Events.logConsumerEvent(eventData);
  }

  static callATCPaymentPaymentBasedOnPaymentType(paymentType = '') {
    if (sentTradeDetailsProgramme()) {
      return true;
    }
    return paymentType.toLowerCase() !== constants.CASH.toLowerCase();
  }
  static getAmountFinanced(payments, showTurnInLease) {
    let value = Payments.conventStringToNumber(payments.PurchasePrice);
    let downpayment = Payments.conventStringToNumber(payments.Downpayment);
    if (downpayment) {
      value = value - downpayment;
    }
    let equity = 0;
    if (+payments.TradeEquity > 0) {
      equity = +payments.TradeEquity;
    } else {
      equity = +payments.TradeEquity * -1;
    }
    if (equity) {
      value = value - equity;
    }
    if (showTurnInLease) {
      value = value + showTurnInLease;
    }
    return value;
  }
}
